/* eslint-disable import/prefer-default-export */

export const addOtherFields = (savedOrder: string[], fieldsName: string[]) => {
    const fieldsUnsaved = fieldsName.filter((el) => !savedOrder.includes(el));
    return [...savedOrder, ...fieldsUnsaved];
};
